import { AppSession } from '@prisma/client'
import { Alert, Flex } from 'antd'
import dayjs from 'dayjs'
import React from 'react'
import { useOrganizationContext } from '~/core/context'
import { useAppSession } from '~/features/appSession/client/hooks/useAppSession'
import { Toolbox } from '~/plugins/toolbox/shared'

type Props = {
  appSession: AppSession
  agentName: string
}

export const RenderUsageLimitReached: React.FC<Props> = ({
  agentName = 'Agent',
  appSession,
}) => {
  const { setStatus } = useAppSession({ appSession })
  const { organization } = useOrganizationContext()

  const now = dayjs()
  const dateReset = organization?.data?.dateResetTokens
  const isToday = now.isSame(dayjs(dateReset), 'day')

  const formatDateReset = () => {
    if (isToday) {
      return Toolbox.Date.toSlackTimeStyle(dateReset)
    } else {
      return Toolbox.Date.toAsanaStyle(dateReset).toLocaleLowerCase()
    }
  }

  const dateResetFormatted = formatDateReset()

  if (!appSession) {
    return null
  }

  return (
    <Flex vertical className="w-full" style={{ padding: '8px 16px' }}>
      <Alert
        icon={<Flex className="pt-3">🎯</Flex>}
        showIcon
        message={`${agentName} has reached their limit and clocked out for the day`}
        description={`All of ${agentName}’s tasks, workflows, and automations are on standby. They will automatically resume ${isToday ? `at ${dateResetFormatted}` : dateResetFormatted}`}
        type="warning"
      />
    </Flex>
  )
}
